<!-- <ion-button fill="clear" (click)="toggleLanguage()" style="display: flex; font-size: 18px;"> -->
<div
  (click)="isMobile() && !isLogged() ? null : toggleLanguage()"
  class="defaultLang"
  [class.notLogged]="!isLogged()"
  translate
>
  <div class="lang-left langContainer">
    @if(isLogged()) {
    <span class="material-symbols-outlined"> language </span>
    {{ selectedLang().toUpperCase() }}

    } @else { @if( isMobile()) {

    <ion-button
      (click)="togglePopover()"
      fill="clear"
      id="lang-trigger"
      class="lang-button"
    >
      {{ selectedLang() }}
      <span
        class="material-symbols-outlined arrow"
        [class.open]="isPopoverOpen()"
      >
        keyboard_arrow_down
      </span>
    </ion-button>

    <ion-popover
      trigger="lang-trigger"
      [isOpen]="isPopoverOpen"
      (didDismiss)="isPopoverOpen.set(false)"
      translucent="true"
      class="lang-popover"
      size="cover"
    >
      <ng-template>
        <ion-list lines="inset">
          <ion-item button (click)="setLang('en')">
            <ion-label> EN </ion-label>
          </ion-item>
          <ion-item button (click)="setLang('es')">
            <ion-label> ES </ion-label>
          </ion-item>
        </ion-list>
      </ng-template>
    </ion-popover>
    } @else {
    <div class="lang-switcher">
      <span class="material-symbols-outlined lang-icon"> translate </span>
      <button class="lang-btn left" [class.active]="selectedLang() === 'es'">
        ES
      </button>
      <span class="divider"></span>
      <button class="lang-btn right" [class.active]="selectedLang() === 'en'">
        EN
      </button>
    </div>
    } }
  </div>
</div>
